import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Address } from 'common/api/models/Address';
import { FormAddressInput } from 'common/components/form/FormAddressInput';
import { Formik } from 'formik';
import { mergeFields } from 'common/utils/form';

interface EditAddressDialogProps {
  address?: Address;
  onSave: (saved: Address) => void;
  onCancel: () => void;
}

export class EditAddressDialog extends React.Component<EditAddressDialogProps> {
  validationSchema = Yup.object().shape({
    street1: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    postal: Yup.string().required('Required'),
    country: Yup.string()
      .required('Required')
      .matches(/^[A-Z]{2}$/, 'Invalid'),
  });

  initialValues() {
    let empty = {
      street1: '',
      street2: '',
      city: '',
      state: '',
      country: '',
      postal: '',
    };
    return mergeFields(empty, this.props.address);
  }

  handleSubmit = (address: Address) => {
    this.props.onSave(address);
  };

  render() {
    return (
      <Modal size="md" isOpen={!!this.props.address} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={form => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>Edit Address</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col">
                    <FormAddressInput form={form} label="Address" />
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/EditAddressDialog.tsx